import { HelperIndex } from "../views";

export const helperRouter = [
  {
    name: "HelperIndex",
    path: "helper/:value?",
    component: HelperIndex,
    props: true
  }
];
